import { openCustomUrlScheme } from '@ps-int/ufo-rocks/lib/helpers/go-to-custom-url-scheme';
import { select } from 'typed-redux-saga';

import { RootState } from '../../../../../init-store';
import { selectResolvedUri } from '../../../../pages/call/features/conference/selectors';
import { selectTelemostHost } from '../selectors';

export function* checkDesktopAppSaga() {
    const {
        ua: { BrowserName },
        sessionId,
        config: { withoutRedirect },
    } = yield* select((state: RootState) => state);
    if (NODE || withoutRedirect) {
        return;
    }

    const resolvedUri = yield* select(selectResolvedUri);
    const currentUrl = new URL(resolvedUri || window.location.href);

    currentUrl.host = yield* select(selectTelemostHost);
    currentUrl.searchParams.set('sessionid', sessionId);

    const url = BrowserName === 'Safari' ? encodeURIComponent(currentUrl.href) : currentUrl.href;
    const urlScheme = `telemost://${url}`;

    openCustomUrlScheme(urlScheme);
}
